import { getProductAnimco } from '@services/animco';
import { cmsService } from '@services/cms';
import { productDetailsService } from '@services/products';

import { WallType } from '@app-types/config';
import { SearchParamsType } from '@app-types/page';

import { PAGE_SLUG } from '@helpers/partials';
import { paths } from '@helpers/path';

import { PlanTypeId } from '@constants/plan';

import { getCurrentProduct } from '@product-detail/helpers';

import { ProductDetail } from './product-detail';

interface HotspotDetailsProps {
    params: { slug: string };
    searchParams?: SearchParamsType;
}

export async function HotspotDetails({ params, searchParams }: Readonly<HotspotDetailsProps>) {
    const { slug } = params;
    const type = WallType.HOTSPOT;

    const product = await productDetailsService.getProductDetails(type, slug);

    const [allPlans, { items: productStatics }] = await Promise.all([
        productDetailsService.getPlans(product.gencode, false, PlanTypeId.FAIM_PREMIUM),
        cmsService.getProduct(),
    ]);

    const { product: productWithStock, currentProduct } = await getCurrentProduct(product, params.slug);

    const animco = getProductAnimco(productStatics, product.urlKey, false);

    return (
        <ProductDetail
            type={type}
            baseUrl={paths.hotspotWall}
            searchParams={searchParams}
            product={productWithStock}
            plans={allPlans}
            currentProduct={currentProduct}
            animco={animco}
            slug={PAGE_SLUG.HOTSPOT}
            planTypeId={PlanTypeId.FAIM_PREMIUM}
            easyTradeInEnabled={false}
        />
    );
}
